module.exports = __webpack_public_path__ + "static/Apercu-Regular-36f209f796db5226e4761d8e07f24a4e.otf";